<template>
  <div class="mainDiv">
    <div class="backBtn" @click="goBack">
      <inline-svg
        class="backs-svg"
        :src="require('../../assets/svg/back.svg').default"
      ></inline-svg>
    </div>
    <p>{{ $t("registration.takanon.title") }}</p>
    <span
      style="width: 100%; font-size: 14px; text-align: var(--src-position);"
      v-html="$t('registration.takanon.text')"
    >
    </span>
    <div class="backBtn" @click="goBack">
      <inline-svg
        class="backs-svg"
        :src="require('../../assets/svg/back.svg').default"
      ></inline-svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "takanon",
  methods: {
    goBack() {
      this.$router.push("/registration");
    }
  }
};
</script>
<style scoped>
.backBtn {
  width: 40px;
  margin: auto;
}
.mainDiv {
  text-align: center;
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// Takanon.vue?5b5334b0